module.exports = __webpack_public_path__ + "static/media/wide_login_icon.60947513.png";